import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { ScrollArea } from '../components/ui/scroll-area';
import { Sheet, SheetContent, SheetTrigger } from '../components/ui/sheet';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from '../components/ui/dropdown-menu';
import {
  LayoutDashboard, Users, Wrench, Package, Building2,
  Clock, CalendarDays, Bell, LogOut, Menu, Shield,
  ClipboardList, ChevronRight, ChevronDown, User, AlertTriangle, FileText, DollarSign, Calculator, Receipt, FolderOpen, BookOpen, FileSpreadsheet, ClipboardPen, KeyRound, AlertCircle, Mail, Upload,
  Truck, ShoppingCart, FileSearch, Contact, Briefcase, HardHat, FileArchive, Settings, Trophy, Phone, UserCircle, Wallet, GanttChartSquare, GraduationCap, Fuel, CreditCard
} from 'lucide-react';
import { useState, useCallback, useMemo } from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cd68a189-b98d-45e1-a777-252a17e84c06/artifacts/mloin8cu_Logo%20Metal%20per%20divise%20SVG.svg";

const sidebarSections = [
  {
    id: 'dashboard',
    type: 'single',
    item: { to: '/', icon: LayoutDashboard, label: 'Dashboard', roles: ['admin', 'capo_cantiere', 'qhse', 'dipendente', 'aspp'] },
  },
  {
    id: 'operativo',
    type: 'group',
    label: 'Operativo',
    icon: HardHat,
    items: [
      { to: '/sites', icon: Building2, label: 'Cantieri', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/project-calendar', icon: FolderOpen, label: 'Progetti', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/client-orders', icon: FileArchive, label: 'Ordini Cliente', roles: ['admin', 'capo_cantiere', 'qhse'] },
      { to: '/work-journal', icon: BookOpen, label: 'Giornale Lavoro', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/production-diary', icon: ClipboardPen, label: 'Diario Produzione', roles: ['admin', 'qhse', 'capo_cantiere', 'aspp'] },
      { to: '/calendario', icon: CalendarDays, label: 'Calendario', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/gantt', icon: GanttChartSquare, label: 'Cronoprogramma', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/scadenze', icon: AlertTriangle, label: 'Scadenze', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/inventory', icon: Package, label: 'Magazzino', roles: ['admin', 'qhse', 'capo_cantiere', 'aspp'] },
      { to: '/equipment', icon: Wrench, label: 'Attrezzature', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
    ],
  },
  {
    id: 'contabilita',
    type: 'group',
    label: 'Contabilita',
    icon: DollarSign,
    items: [
      { to: '/scadenziario', icon: Wallet, label: 'Scadenziario', roles: ['admin', 'qhse'] },
      { to: '/site-accounting', icon: DollarSign, label: 'Contabilita', roles: ['admin'] },
      { to: '/bank-statements', icon: Wallet, label: 'Estratti Conto', roles: ['admin', 'qhse'] },
      { to: '/sal', icon: Calculator, label: 'SAL', roles: ['admin', 'capo_cantiere'] },
      { to: '/ses-matrices', icon: FileSpreadsheet, label: 'Matrici SES (Sarpom)', roles: ['admin', 'qhse', 'capo_cantiere'] },
      { to: '/sal-fiumicino', icon: Calculator, label: 'SAL Fiumicino', roles: ['admin', 'qhse', 'capo_cantiere'] },
      { to: '/quotes', icon: ClipboardList, label: 'Preventivi', roles: ['admin', 'capo_cantiere'] },
      { to: '/expense-claims', icon: Receipt, label: 'Rimborsi Spese', roles: ['admin', 'qhse', 'capo_cantiere', 'aspp'] },
      { to: '/fornitori', icon: Contact, label: 'Anagrafica Fornitori', roles: ['admin', 'qhse', 'capo_cantiere'] },
      { to: '/documents', icon: FileText, label: 'DDT / Ordini / RDO', roles: ['admin', 'qhse', 'capo_cantiere'] },
      { to: '/invoices', icon: Receipt, label: 'Fatture e Pagamenti', roles: ['admin', 'capo_cantiere', 'qhse'] },
      { to: '/prezziario', icon: BookOpen, label: 'Prezziario', roles: ['admin', 'qhse', 'capo_cantiere'] },
      { to: '/prezziario-pdf', icon: FileText, label: 'Prezziario PDF', roles: ['admin', 'qhse', 'capo_cantiere'] },
      { to: '/contacts', icon: Contact, label: 'Rubrica Contatti', roles: ['admin', 'qhse', 'capo_cantiere', 'dipendente', 'aspp'] },
      { to: '/payment-cards', icon: Fuel, label: 'Carte Carburante e Telepass', roles: ['admin', 'qhse'] },
      { to: '/le-mie-carte', icon: CreditCard, label: 'Le Mie Carte', roles: ['admin', 'qhse', 'capo_cantiere', 'dipendente', 'aspp'] },
    ],
  },
  {
    id: 'risorse_umane',
    type: 'group',
    label: 'Risorse Umane',
    icon: Users,
    items: [
      { to: '/employees', icon: Users, label: 'Personale', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/training-overview', icon: GraduationCap, label: 'Scadenze Formazione', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/email-archive', icon: FileArchive, label: 'Archivio Formazione e Idoneità', roles: ['admin', 'qhse', 'aspp'] },
      { to: '/recruitment', icon: GraduationCap, label: 'Campagna Assunzioni', roles: ['admin', 'capo_cantiere', 'qhse'] },
      { to: '/attendance', icon: Clock, label: 'Presenze', roles: ['admin', 'capo_cantiere', 'qhse', 'dipendente', 'aspp'] },
      { to: '/leaves', icon: CalendarDays, label: 'Ferie / Permessi', roles: ['admin', 'capo_cantiere', 'qhse', 'dipendente', 'aspp'] },
      { to: '/oncall', icon: Phone, label: 'Reperibilita', roles: ['admin', 'capo_cantiere', 'qhse', 'dipendente', 'aspp'] },
      { to: '/area-dipendente', icon: UserCircle, label: 'Area Dipendente', roles: ['admin', 'capo_cantiere', 'qhse', 'dipendente', 'aspp'] },
      { to: '/area-dipendente?tab=rimborsi', icon: Wallet, label: 'Richiedi Rimborso', roles: ['dipendente'] },
      { to: '/employee-reports', icon: FileSpreadsheet, label: 'Report Dipendenti', roles: ['admin', 'qhse', 'capo_cantiere', 'aspp'] },
      { to: '/buste-paga', icon: Receipt, label: 'Buste Paga', roles: ['admin', 'qhse'] },
    ],
  },
  {
    id: 'sicurezza',
    type: 'group',
    label: 'Sicurezza',
    icon: Shield,
    items: [
      { to: '/incidents', icon: AlertCircle, label: 'Non Conformita', roles: ['admin', 'qhse', 'aspp'] },
      { to: '/segnalazioni', icon: ClipboardList, label: 'Segnalazioni', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/safety-points', icon: Shield, label: 'Punti Sicurezza', roles: ['admin', 'qhse', 'capo_cantiere', 'dipendente', 'aspp'] },
      { to: '/safety-devices', icon: HardHat, label: 'Dispositivi Sicurezza', roles: ['admin', 'qhse', 'capo_cantiere', 'dipendente', 'aspp'] },
    ],
  },
  {
    id: 'regards',
    type: 'single',
    item: { to: '/regards', icon: Trophy, label: 'REGARDS', roles: ['admin', 'capo_cantiere', 'qhse', 'dipendente', 'aspp'] },
  },
  {
    id: 'documenti',
    type: 'group',
    label: 'Documenti',
    icon: FileText,
    items: [
      { to: '/my-docs', icon: FolderOpen, label: 'I Miei Documenti', roles: ['admin', 'qhse', 'capo_cantiere', 'dipendente', 'aspp'] },
      { to: '/project-docs', icon: FolderOpen, label: 'Archivio Documenti', roles: ['admin', 'qhse', 'capo_cantiere', 'aspp'] },
      { to: '/company-docs', icon: FileText, label: 'Doc. Aziendali', roles: ['admin', 'qhse', 'aspp'] },
      { to: '/reports', icon: FileSpreadsheet, label: 'Report', roles: ['admin', 'qhse', 'capo_cantiere', 'aspp'] },
      { to: '/portals', icon: KeyRound, label: 'Portali e Password', roles: ['admin', 'capo_cantiere', 'qhse', 'aspp'] },
      { to: '/data-import', icon: Upload, label: 'Importa Dati', roles: ['admin', 'qhse', 'aspp'] },
    ],
  },
  {
    id: 'amministrazione',
    type: 'group',
    label: 'Amministrazione',
    icon: Settings,
    items: [
      { to: '/users', icon: Shield, label: 'Gestione Utenti', roles: ['admin'] },
      { to: '/email-settings', icon: Mail, label: 'Config. Email', roles: ['admin'] },
      { to: '/notifications', icon: Bell, label: 'Notifiche', roles: ['admin', 'capo_cantiere', 'qhse', 'dipendente', 'aspp'] },
    ],
  },
];

function getInitialExpanded() {
  try {
    const saved = localStorage.getItem('sidebar_expanded');
    if (saved) return JSON.parse(saved);
  } catch {}
  return { operativo: true, contabilita: true, risorse_umane: true, sicurezza: true, regards: true, documenti: false, amministrazione: false };
}

function SidebarNav({ onNavigate }) {
  const { user } = useAuth();
  const role = user?.role_name;
  const location = useLocation();
  const [expanded, setExpanded] = useState(getInitialExpanded);

  const toggleSection = useCallback((id) => {
    setExpanded(prev => {
      const next = { ...prev, [id]: !prev[id] };
      try { localStorage.setItem('sidebar_expanded', JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  const activeRoutes = useMemo(() => {
    const path = location.pathname;
    const activeSet = new Set();
    for (const section of sidebarSections) {
      if (section.type === 'group') {
        for (const item of section.items) {
          if (path === item.to || (item.to !== '/' && path.startsWith(item.to))) {
            activeSet.add(section.id);
          }
        }
      }
    }
    return activeSet;
  }, [location.pathname]);

  return (
    <nav className="flex flex-col gap-0.5 px-3" data-testid="sidebar-nav">
      {sidebarSections.map((section) => {
        if (section.type === 'single') {
          const item = section.item;
          if (!item.roles.includes(role)) return null;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end
              onClick={onNavigate}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              data-testid={`nav-${item.label.toLowerCase().replace(/[\s/]/g, '-')}`}
            >
              <item.icon size={18} strokeWidth={1.5} />
              <span>{item.label}</span>
            </NavLink>
          );
        }

        const visibleItems = section.items.filter(i => i.roles.includes(role));
        if (visibleItems.length === 0) return null;

        const isExpanded = expanded[section.id] || activeRoutes.has(section.id);
        const hasActive = activeRoutes.has(section.id);
        const SectionIcon = section.icon;

        return (
          <div key={section.id} className="mt-1" data-testid={`section-${section.id}`}>
            <button
              onClick={() => toggleSection(section.id)}
              className={`sidebar-section-header ${hasActive ? 'has-active' : ''}`}
              data-testid={`section-toggle-${section.id}`}
            >
              <SectionIcon size={16} strokeWidth={1.5} />
              <span className="flex-1 text-left">{section.label}</span>
              <ChevronDown
                size={14}
                className={`sidebar-chevron ${isExpanded ? 'expanded' : ''}`}
              />
            </button>
            <div className={`sidebar-section-items ${isExpanded ? 'open' : ''}`}>
              <div className="sidebar-section-inner">
                {visibleItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === '/'}
                    onClick={onNavigate}
                    className={({ isActive }) => `sidebar-link sidebar-link-nested ${isActive ? 'active' : ''}`}
                    data-testid={`nav-${item.label.toLowerCase().replace(/[\s/]/g, '-')}`}
                  >
                    <item.icon size={16} strokeWidth={1.5} />
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </nav>
  );
}

export default function Layout() {
  const { user, logout, unreadCount } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex fixed inset-y-0 left-0 z-50 w-64 flex-col bg-white border-r border-slate-200">
        <div className="flex items-center gap-3 h-16 px-4 border-b border-slate-200">
          <img src={LOGO_URL} alt="Metal Covering" className="h-10 w-auto" />
          <div className="flex flex-col">
            <span className="text-sm font-bold text-[hsl(230,50%,20%)] leading-tight">Metal Covering</span>
            <span className="text-[10px] text-slate-500">S.r.l.</span>
          </div>
        </div>
        <ScrollArea className="flex-1 py-4">
          <SidebarNav />
        </ScrollArea>
        <div className="p-4 border-t border-slate-200">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center">
              <User size={14} className="text-slate-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-slate-900 truncate">{user?.email}</p>
              <p className="text-[10px] text-slate-500">{user?.role_display || user?.role_name}</p>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content Area */}
      <div className="lg:pl-64">
        {/* Header */}
        <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-200 h-14 flex items-center px-4 lg:px-6 gap-4">
          {/* Mobile menu */}
          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon" data-testid="mobile-menu-btn">
                <Menu size={20} />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-64 p-0 flex flex-col h-full">
              <div className="flex items-center gap-3 h-16 px-4 border-b border-slate-200 flex-shrink-0">
                <img src={LOGO_URL} alt="Metal Covering" className="h-10 w-auto" />
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-[hsl(230,50%,20%)] leading-tight">Metal Covering</span>
                  <span className="text-[10px] text-slate-500">S.r.l.</span>
                </div>
              </div>
              <ScrollArea className="flex-1 py-4">
                <SidebarNav onNavigate={() => setMobileOpen(false)} />
              </ScrollArea>
            </SheetContent>
          </Sheet>

          <div className="flex-1" />

          {/* Notifications Bell */}
          <Button
            variant="ghost"
            size="icon"
            className="relative"
            onClick={() => navigate('/notifications')}
            data-testid="notifications-bell"
          >
            <Bell size={18} />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </Button>

          {/* User Menu */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className="gap-2" data-testid="user-menu-btn">
                <div className="w-7 h-7 rounded-full bg-[hsl(230,50%,20%)] text-white flex items-center justify-center text-xs font-bold">
                  {user?.email?.[0]?.toUpperCase()}
                </div>
                <ChevronRight size={14} className="text-slate-400" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <div className="px-3 py-2">
                <p className="text-sm font-semibold">{user?.email}</p>
                <p className="text-xs text-slate-500">{user?.role_display || user?.role_name}</p>
              </div>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => navigate('/change-password')} data-testid="change-password-menu-btn">
                <KeyRound size={14} className="mr-2" />
                Cambia Password
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleLogout} data-testid="logout-btn">
                <LogOut size={14} className="mr-2" />
                Esci
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </header>

        {/* Page Content */}
        <main className="p-4 lg:p-6 pb-6">
          <Outlet />
        </main>
        
        {/* Footer Branding */}
        <footer className="border-t border-slate-100 py-2 px-4 bg-white/80">
          <div className="flex items-center justify-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_e10f3dc4-f435-40b4-9aef-2385ba08ebcf/artifacts/j4emni6w_Progetto%20senza%20titolo%20%2848%29.png" 
              alt="Wet Industries" 
              className="h-4 w-4 rounded"
            />
            <span className="text-[10px] text-slate-400">
              Created by Gianluca Bagnato with Wet Industries inc. for Metal Covering s.r.l.
            </span>
          </div>
        </footer>
      </div>
    </div>
  );
}
